export const getFileNameExtension = (filename) => {
  const parts = filename.split(".");
  const fileExtension = parts.slice(-1).join(".");
  return `.${fileExtension}`;
};
